import { Button, ButtonProps } from 'modules';
import React, { useContext } from 'react';
import { WebsocketActions, WebsocketContext } from 'services/WebsocketContext';
import { FormScene } from 'constants/FormScene';

interface GoBackButtonProps extends ButtonProps {
  step: FormScene;
}

const GoBackButton = ({ step, ...props }: GoBackButtonProps) => {
  const wsContext = useContext(WebsocketContext);

  const goBack = () => {
    wsContext?.send({
      action: WebsocketActions.STEP_CHANGE,
      value: step,
    });
  };

  return (
    <Button type="button" variant={'light'} className="mr-2" {...props} onClick={goBack}>
      Späť
    </Button>
  );
};

export default GoBackButton;
